import styled, { css } from 'styled-components'

import { getResponsiveFontSizeCSS } from 'helpers/css'

export const Container = styled.div``

export const Main = styled.div`
    background-color: white;
    min-height: 50px;
    min-width: 320px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px 0px 0px 6px;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 10px;
    position: relative;
`

export const Type = styled.div`
    position: absolute;
    background-color: ${({ color }) => color};
    width: 18%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px 0px 0px 6px;
`

export const Icon = styled.img``

export const MessageWrap = styled.div`
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    ${props => {
        const { marginLeft, padding, flexDirection } = props
        return css`
            margin-left: ${marginLeft};
            padding: ${padding};
            flex-direction: ${flexDirection};
        `
    }}
`

export const Message = styled.div`
    font-family: AvenirBold;
    font-weight: 600;
    margin-bottom: ${({ marginBottom }) => `${marginBottom}px`};
    font-size: ${getResponsiveFontSizeCSS(14, 20)};
    color: #555555;
`

export const Prefix = styled.div`
    font-family: AvenirBold;
    font-weight: 600;
    font-size: ${getResponsiveFontSizeCSS(14, 20)};
    margin-right: 6px;
    color: #ef5c34;
`
